import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import * as routes from '../../routes/deliveries.routes'
import { parseToMysqlFormat } from '../../../util/date.service'

const JustificativaCargasParadasHttp = {
  async getDeliveriesToJustify(tp_id, pInicial, pFinal, company_id, identifier) {
    try {
      const result = await authHttp().get(
        routes.urlGetDeliveriesToJustify(
          tp_id,
          parseToMysqlFormat(pInicial),
          parseToMysqlFormat(pFinal),
          company_id,
          identifier,
        ),
      )
      return result.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async saveJustifyToDeliveries(selectedTp, data) {
    try {
      const response = await authHttp().put(routes.urlSaveJustifyToDeliveries(selectedTp), data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
}

export default JustificativaCargasParadasHttp
